import React from "react";
import { Circle, Popup } from "react-leaflet";

interface StopCircleProps {
  position: [number, number];
  duration: number; // duração da parada em minutos
  popupContent: React.ReactNode;
}

export const StopCircle: React.FC<StopCircleProps> = ({
  position,
  duration,
  popupContent,
}) => {
  // Calcular o raio do círculo baseado na duração da parada
  // Vamos usar uma escala onde 1 minuto = 1 metro de raio, com um mínimo de 5 metros
  const radius = Math.max(duration, 5);

  return (
    <Circle
      center={position}
      radius={radius}
      pathOptions={{ color: "red", fillColor: "red", fillOpacity: 0.2 }}
    >
      <Popup>{popupContent}</Popup>
    </Circle>
  );
};
